// src/screens/DataDeletionScreen/index.ts
import React, { FC } from 'react';
import ScreenLayout from 'components/ScreenLayout';

import DataDeletion from './components/DataDeletion';
import DataDeletionConfirm from './components/DataDeletionConfirm';

export const DataDeletionScreen: FC = () => (
  <ScreenLayout>
    <DataDeletion />
  </ScreenLayout>
);

export const DataDeletionConfirmScreen: FC = () => (
  <ScreenLayout>
    <DataDeletionConfirm />
  </ScreenLayout>
);